var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7669 17.2913L17.2616 13.3971C17.1034 13.2214 16.8889 13.1237 16.6639 13.1237H16.0908C17.0612 11.7449 17.6378 10.0107 17.6378 8.12421C17.6378 3.63636 14.3645 0 10.3248 0C6.285 0 3.01172 3.63636 3.01172 8.12421C3.01172 12.612 6.285 16.2484 10.3248 16.2484C12.0229 16.2484 13.584 15.6079 14.8251 14.5298V15.1665C14.8251 15.4165 14.913 15.6547 15.0712 15.8305L18.5765 19.7246C18.907 20.0918 19.4414 20.0918 19.7684 19.7246L20.7634 18.6193C21.0939 18.2521 21.0939 17.6584 20.7669 17.2913ZM10.3248 13.1237C7.83902 13.1237 5.82442 10.8896 5.82442 8.12421C5.82442 5.36276 7.83551 3.12469 10.3248 3.12469C12.8105 3.12469 14.8251 5.35885 14.8251 8.12421C14.8251 10.8857 12.814 13.1237 10.3248 13.1237Z",
    fill: "#CB3050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ba6c9c55d1b09e2edb37371a72be5b8e.svg";
export { ForwardRef as ReactComponent };